import { render, staticRenderFns } from "./activity-bar.vue?vue&type=template&id=f73d72c4&scoped=true"
import script from "./activity-bar.vue?vue&type=script&lang=js"
export * from "./activity-bar.vue?vue&type=script&lang=js"
import style0 from "./activity-bar.vue?vue&type=style&index=0&id=f73d72c4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f73d72c4",
  null
  
)

export default component.exports